'use client';

import {useOmicronClientFlag} from '@web-catalog/hooks/omicron';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {SpriteIcon} from '@web-catalog/ui-kit/SpriteIcon';

import {logAuthorizationMenuProfileIconClick} from '@web-catalog/utils/analytics/authAnalytics';

import styles from './AuthMenuComponent.module.scss';
import {Avatar} from './parts/Avatar';

export const AuthMenuComponent = () => {
  const webAvailableAutoLoginType = useOmicronClientFlag('WEB_AUTO_LOGIN');
  const userInfo = useAuthorizedProfile();

  if (!userInfo?.id || webAvailableAutoLoginType !== 'headerAvatar') {
    return;
  }

  return (
    <div
      className={styles.container}
      onClick={logAuthorizationMenuProfileIconClick}
      data-testid="auth-menu-comp"
    >
      <Avatar size={40} className={styles.avatar} />
      <div className={styles.user}>
        <div className={styles.name}>
          {userInfo?.first_name ?? `id${userInfo?.id}`}
        </div>
        <div className={styles.id}>
          Вы вошли с помощью <span className="visually-hidden">VK ID</span>
          <SpriteIcon svg="vk_id" color="black" />
        </div>
      </div>
    </div>
  );
};
